import axios from 'axios'
import * as utils from './api-utils'

export default {
  index() {
    return axios.get(utils.getApiUrl('/pole_masters'))
  },
}
